export const ACTIONS = require("./actions")
export const ENDPOINTS = require("./endpoints")
export const clearFicheAntirabique = () =>  ({
  type: ACTIONS.CLEAR_FICHE_ANTIRABIQUE
})